import {
  AddressFields,
  ContactFields,
  PaymentMethodState,
  AddressFieldsState,
} from "../../types";

import {
  CustomerOrderResponse,
  ReducedOrder,
  ReducedShippingInfo,
  PaymentMethod,
} from "../../generated/graphql";

export type ViewState = PendingViewState | SuccessViewState;

export interface PendingViewState {
  type: "pending";
  isLoading: boolean;
  contactFields: ContactFields;
  shippingAddress: AddressFieldsState;
  paymentMethodState: PaymentMethodState;
  isButtonDisabled: boolean;
  isWalletButtonDisabled: boolean;
  customerOrder: CustomerOrderResponse;
  paymentMethodList: PaymentMethod[];
  isPaymentMethodLoading: boolean;
}

export interface SuccessViewState {
  type: "success";
  paymentType: string;
  shippingInfo: ReducedShippingInfo;
  order: ReducedOrder;
}

function isContactFieldsInvalid(contactFields: ContactFields): boolean {
  return contactFields.name === "" || contactFields.phone === "";
}

function isShippingAddressInvalid(
  customerOrder: CustomerOrderResponse,
  shippingAddress: AddressFields
): boolean {
  return (
    customerOrder.order.shipmentRequired &&
    (shippingAddress.country === "" ||
      shippingAddress.address1 === "" ||
      shippingAddress.address2 === "")
  );
}

function isCustomerPaymentInvalid(
  paymentMethodState: PaymentMethodState
): boolean {
  return (
    paymentMethodState.type === "custom" &&
    (paymentMethodState.receiptAttachments.length === 0 ||
      paymentMethodState.receiptAttachments.filter(a => a.assetId === null)
        .length > 0)
  );
}

function isStripeCreditCardPaymentInvalid(
  paymentMethodState: PaymentMethodState
): boolean {
  if (paymentMethodState.type !== "stripeCreditCard") {
    return false;
  }

  if (!paymentMethodState.isCreditCardComplete) {
    return true;
  }

  if (
    !paymentMethodState.isUsingShipmentAddressForBilling &&
    (paymentMethodState.billingAddress.country === "" ||
      paymentMethodState.billingAddress.address1 === "" ||
      paymentMethodState.billingAddress.address2 === "")
  ) {
    return true;
  }

  return false;
}

export function checkShouldButtonDisabled(
  contactFields: ContactFields,
  customerOrder: CustomerOrderResponse,
  shippingAddress: AddressFields,
  paymentMethodState: PaymentMethodState
): boolean {
  return (
    isContactFieldsInvalid(contactFields) ||
    isShippingAddressInvalid(customerOrder, shippingAddress) ||
    isCustomerPaymentInvalid(paymentMethodState) ||
    isStripeCreditCardPaymentInvalid(paymentMethodState)
  );
}

export function checkShouldWalletButtonDisabled(
  contactFields: ContactFields,
  customerOrder: CustomerOrderResponse,
  shippingAddress: AddressFields
): boolean {
  return (
    isContactFieldsInvalid(contactFields) ||
    isShippingAddressInvalid(customerOrder, shippingAddress)
  );
}
